// Importaciones de componentes y librerías necesarias
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { createContext, useEffect, useState, useMemo } from "react";
import Box from "@mui/material/Box";
import { SolicitudDeCreditoGeneralesFisica } from "./SolitudDeCredito/SolicitudDeCreditoGenerales";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CallIcon from "@mui/icons-material/Call";
import HouseIcon from "@mui/icons-material/House";
import GrassIcon from "@mui/icons-material/Grass";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import FloodIcon from "@mui/icons-material/Flood";
import SoliciitudDeCreditoCultivos from "./SolitudDeCredito/SoliciitudDeCreditoCultivos";
import SolicitudDecreditoContacto from "./SolitudDeCredito/SolicitudDecreditoContacto";
import SolicitudDeCreditoDomicilio from "./SolitudDeCredito/SolicitudDeCreditoDomicilio";
import SolicitudDeCreditoBalancePatrimonial from "./SolitudDeCredito/SolicitudDeCreditoBalancePatrimonial";
import SolicitudDecreditoSiniestros from "./SolitudDeCredito/SolicitudeCreditoSiniestros";
import SolicitudDeCreditoOtrosIngresos from "./SolitudDeCredito/SolicitudDeCreditoOtrosIngresos";
import SolicitudDeCreditoIngresosYEgresos from "./SolitudDeCredito/SolicitudDeCreditoIngresosYEgresos";
import CustomTabPanel from "../../../components/TabPanels/CustomTabPanel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory, useLocation } from "react-router-dom";

import { LoaderScreen } from "../../../components/LoaderScreen";

// Creación del contexto para compartir datos entre componentes
export const Context = createContext(null);

// Componente para manejar los paneles de las pestañas

function DashCrearSolicitudCreditoTabs(props) {
  const location = useLocation();
  // Estado para manejar el valor de la pestaña seleccionada
  const [value, setValue] = useState(0);
  // Estado adicional para el índice del tab actual

  const [screen, setScreen] = useState(0);
  const [stateSC, setStateSC] = useState({
    datoscontactos: false,
    domicilios: false,
    cultivos: false,
    balancepatrimonial: false,
    ingresosyegresos: false,
    otrosingresos: false,
    siniestros: false,
  });

  // Estado para manejar los datos de la solicitud de crédito
  const [stateSolicitudCredito, setStateSolicitudCredito] = useState({
    folio: props.folio,
    idCliente: props.idcliente,
  });
  const [botonsiguinete, setBotonSiguiente] = useState(() => <div></div>);
  // Función para cambiar el valor de la pestaña seleccionada
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const contextValue = useMemo(
    () => ({
      state: stateSolicitudCredito,
      stateSC,
      setState: setStateSolicitudCredito,
      setStateSC,
    }),
    [stateSolicitudCredito, setStateSolicitudCredito, stateSC, setStateSC]
  );

  const history = useHistory();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const handleNext = (nextIndex) => {
    // const nextIndex = screen + 1;
    if (nextIndex < 5) {
      setValue(nextIndex);
      setScreen(nextIndex);
    }
  };

  useEffect(() => {
    if (
      stateSolicitudCredito.folio === undefined ||
      stateSolicitudCredito.folio === null ||
      stateSolicitudCredito.folio.length !== 13
    ) {
      history.push("/DashClientes/solicitudcreditoGenerar", {
        idcliente: stateSolicitudCredito.idCliente,
      });
    } else {
      if (location.state.vista !== undefined && location.state.vista !== null) {
        setScreen(Number(location.state.vista) + 0);
        if (Number(location.state.vista) >= 7) {
          setValue(0);
        } else {
          setValue(Number(location.state.vista) + 1);
        }
      }
    }
  }, []);

  useEffect(() => {
    var datoscontactos = Number(screen) >= 1 ? false : true;
    var domicilios = Number(screen) >= 2 ? false : true;
    var cultivos = Number(screen) >= 3 ? false : true;
    var balancepatrimonial = Number(screen) >= 4 ? false : true;
    var ingresosyegresos = Number(screen) >= 5 ? false : true;
    var otrosingresos = Number(screen) >= 6 ? false : true;
    var siniestros = Number(screen) >= 7 ? false : true;

    setStateSC({
      ...stateSC,
      datoscontactos,
      domicilios,
      cultivos,
      balancepatrimonial,
      ingresosyegresos,
      otrosingresos,
      siniestros,
    });
  }, [screen]);

  return (
    <Context.Provider value={contextValue}>
      <div className="crm-main-screen">
        <LoaderScreen loader={loader} />
        <div className="crm-body">
          <div className="crm-page">
            <div className="crm-module">
              <div className="crm-module-head">
                <div className="crm-head-grid">
                  <div className="crm-head-left">
                    <button
                      className="crm-btn-regresar"
                      onClick={() =>
                        history.push("/DashClientes/solicitudcreditoGenerar", {
                          folio: stateSolicitudCredito.folio,
                          idcliente: stateSolicitudCredito.idCliente,
                        })
                      }
                    >
                      <ArrowBackIcon /> Regresar
                    </button>
                  </div>
                  <div className="crm-head-center">
                    <h1 className="crm-module-title">CAPTURA DE SOLICITUD</h1>
                  </div>
                  <div className="crm-head-right" />
                </div>
                <div className="crm-head-divider">
                  <div className="crm-head-divider-dot" />
                </div>
              </div>
        <Box className="solicitud-credito-container-tabs">
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons
              sx={{
                [`& .${tabsClasses.scrollButtons}`]: {
                  "&.Mui-disabled": { opacity: 0.3 },
                },
              }}
            >
              <Tab icon={<AccountCircleIcon />} label="Datos Generales" />
              <Tab
                // disabled={stateSC.datoscontactos}
                icon={<CallIcon />}
                label="Datos de contacto"
              />
              <Tab
                // disabled={stateSC.domicilios}
                icon={<HouseIcon />}
                label="Domicilio"
              />
              <Tab
                // disabled={stateSC.cultivos}
                icon={<GrassIcon />}
                label="Cultivos sembrados"
              />
              {/* <Tab
              disabled={stateSC.balancepatrimonial}
              icon={<AccountBalanceIcon />}
              label="Balance Patrimonial"
            /> */}
              {/* <Tab
              disabled={stateSC.ingresosyegresos}
              icon={<AttachMoneyIcon />}
              label="Ingresos y egresos"
            /> */}
              {/* <Tab
              disabled={stateSC.otrosingresos}
              icon={<AttachMoneyIcon />}
              label="Otros ingresos"
            /> */}
              {/* <Tab
              disabled={stateSC.siniestros}
              icon={<FloodIcon />}
              label="Siniestros"
            /> */}
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <SolicitudDeCreditoGeneralesFisica
              value={value}
              loader={loader}
              setLoader={setLoader}
              onNext={handleNext}
              setBotonSiguiente={setBotonSiguiente}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <SolicitudDecreditoContacto
              setValue={setValue}
              setScreen={setScreen}
              screen={screen}
              loader={loader}
              setLoader={setLoader}
              onNext={handleNext}
              setBotonSiguiente={setBotonSiguiente}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <SolicitudDeCreditoDomicilio
              setValue={setValue}
              setScreen={setScreen}
              screen={screen}
              loader={loader}
              setLoader={setLoader}
              onNext={handleNext}
              setBotonSiguiente={setBotonSiguiente}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <SoliciitudDeCreditoCultivos
              setValue={setValue}
              setScreen={setScreen}
              screen={screen}
              loader={loader}
              setLoader={setLoader}
              onNext={handleNext}
              setBotonSiguiente={setBotonSiguiente}
            />
          </CustomTabPanel>
          {/* <CustomTabPanel value={value} index={4}>
          <SolicitudDeCreditoBalancePatrimonial
            setValue={setValue}
            setScreen={setScreen}
            screen={screen}
            loader={loader}
            setLoader={setLoader}
            onNext={handleNext}
            value={value}
          />
        </CustomTabPanel> */}
          {/* <CustomTabPanel value={value} index={5}>
          <SolicitudDeCreditoIngresosYEgresos
            setValue={setValue}
            setScreen={setScreen}
            screen={screen}
            loader={loader}
            setLoader={setLoader}
            onNext={handleNext}
          />
        </CustomTabPanel> */}
          {/* <CustomTabPanel value={value} index={6}>
          <SolicitudDeCreditoOtrosIngresos
            setValue={setValue}
            setScreen={setScreen}
            screen={screen}
            loader={loader}
            setLoader={setLoader}
            onNext={handleNext}
          />
        </CustomTabPanel> */}
          {/* <CustomTabPanel value={value} index={7}>
          <SolicitudDecreditoSiniestros
            setValue={setValue}
            setScreen={setScreen}
            screen={screen}
            loader={loader}
            setLoader={setLoader}
            onNext={handleNext}
          />
        </CustomTabPanel> */}
        </Box>
              <div className="footer-solicitud-credito">
                {botonsiguinete}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Context.Provider>
  );
}

// Exportación del componente principal
export default DashCrearSolicitudCreditoTabs;
